/* eslint-disable react/prop-types */
import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
// import Button from '@mui/material/Button';
import Button from "../Button";
import InputField from "../InputField";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  borderRadius: "5px",
  boxShadow: 24,
  p: 4,
};

function EditModal({
  isOpen,
  handleClose,
  handleSubmit,
  onChange,
  heading,
  placeholder,
  initialValue,
}) {
  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={modalStyle}>
        <h2 id="modal-title">{heading}</h2>
        <InputField
          placeholder={placeholder}
          onChange={onChange}
          customvalue={initialValue}
        />
        <Box
          sx={{
            display: "flex",
            gap: "20px",
            alignItems: "center",
            marginTop: "20px",
          }}
        >
          <Button onClick={handleSubmit}>Submit</Button>
          <Button cancel onClick={handleClose}>
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default EditModal;
